import React, { useContext, useEffect } from 'react'

//Router dom
import { Route, Routes, useLocation } from 'react-router-dom';

import { getSession } from '../actions/sso';

import Auth from '../Components/SSO/Auth';
import Login from '../Components/SSO/Login';

import { RouterContext } from '../context/RouterContext';

import { PublicRoute } from './PublicRoute';
import { AdminRoutes } from './AdminRoutes';
import { ProtectedRoute } from './ProtectedRoute';

import { Container, CircularProgress } from '@mui/material';

import AppSnackbar from '../Components/AppSnackbar';

const AppRoute = () => {
    const { pathname } = useLocation();
    const { item: { loadingSession }, setItem } = useContext(RouterContext);

    useEffect(() => {
        if (pathname !== '/auth_oauth/signin')
            // sesión de usuario se actualiza
            getSession(setItem);
        else
            setItem(e => ({ ...e, loadingSession: false }));
    }, []);

    if (loadingSession)
        return (
            <Container maxWidth='xl' sx={{ textAlign: 'center', mt: 5 }}>
                <CircularProgress />
            </Container>
        );

    return (
        <>
            <Routes>
                <Route path="/:msg?" element={
                    <PublicRoute>
                        <Login />
                    </PublicRoute>
                } />
                <Route path="/admin/*" element={
                    <ProtectedRoute>
                        <AdminRoutes />
                    </ProtectedRoute>
                } />
                <Route path="/auth_oauth/signin" element={<Auth />} />
            </Routes>
            
            <AppSnackbar />
        </>
    );
};

export default AppRoute;